export default "__VITE_ASSET__CtYyMJvd__"